import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { VicnamesSearchService } from '@lassi/webapp-shared';

export const polygonSearchResolver: ResolveFn<string> = () => {
  const service = inject(VicnamesSearchService);

  const polygon = service.polygonSearch();

  if (!polygon) {
    // If no current polygon, use stored GeoJSON from last search
    return service.lastPolygonGeoJson() ?? '';
  }

  try {
    return JSON.stringify(polygon.toGeoJSON().geometry);
  } catch (error) {
    // If polygon object is invalid, fall back to stored GeoJSON
    console.error('Error getting polygon GeoJSON, using stored value:', error);
    return service.lastPolygonGeoJson() ?? '';
  }
};
